import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CategoriesSection from './components/CategoriesSection';
import ComparisonSection from './components/ComparisonSection';
import TestimonialsSection from './components/TestimonialsSection';
import ArticlesSection from './components/ArticlesSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL;

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AboutSection />
        <CategoriesSection />
        <ComparisonSection />
        <TestimonialsSection />
        <ArticlesSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Best AllChinaBuy Spreadsheet 2026 – Trusted Finds & Buying Guides",
        "description": "Discover the best AllChinaBuy Spreadsheet for fashion, sneakers, designer brands, and trusted sellers. Updated daily with buying guides, QC tips, and safety advice.",
        "url": siteUrl + "/",
        "image": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg",
        "mainEntity": {
          "@type": "FAQPage",
          "mainEntity": [
            { "@type": "Question", "name": "What is an AllChinaBuy Spreadsheet?", "acceptedAnswer": { "@type": "Answer", "text": "An AllChinaBuy spreadsheet is a curated, regularly updated list of products available through the AllChinaBuy platform. It organizes items by category, brand, seller rating, and price." } },
            { "@type": "Question", "name": "How often is the spreadsheet updated?", "acceptedAnswer": { "@type": "Answer", "text": "Our AllChinaBuy spreadsheet is updated daily with new finds, removed outdated listings, and refreshed seller ratings." } },
            { "@type": "Question", "name": "Can beginners use the AllChinaBuy spreadsheet?", "acceptedAnswer": { "@type": "Answer", "text": "Absolutely. The spreadsheet is designed with beginners in mind, with step-by-step guides, safety tips, and clear category organization." } },
            { "@type": "Question", "name": "Is shipping information included?", "acceptedAnswer": { "@type": "Answer", "text": "Yes, our buying guides include detailed shipping information, estimated delivery times, and recommendations for reliable shipping methods." } }
          ]
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": siteUrl + "/" }
          ]
        }
      }) }} />
    </>
  );
}